module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "dropzone"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "",
      "id": "uploadInput",
      "name": _vm.nomeCampoDeEnvio,
      "accept": "image/*,.pdf"
    },
    on: {
      "change": function($event) {
        _vm.incluiArquivos($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length;
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.arquivosPainel), function(arquivo) {
    return _c('tr', {
      key: arquivo.name
    }, [_c('td', {
      staticClass: "esquerda"
    }, [_c('span', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!arquivo.id),
        expression: "!arquivo.id"
      }],
      staticClass: "fa fa-times fa-lg icone-lista arquivo-nao-enviado",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (arquivo.id),
        expression: "arquivo.id"
      }],
      staticClass: "fa fa-check fa-lg icone-lista arquivo-enviado",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" \n        ")])]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(arquivo.name) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "direita"
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.podeDeletar),
        expression: "podeDeletar"
      }],
      staticClass: "icone-lista botao-direita tira-da-lista",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletaArquivo(arquivo)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (arquivo.id),
        expression: "arquivo.id"
      }],
      staticClass: "icone-lista botao-direita download-arquivo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.download(arquivo)
        }
      }
    }, [_vm._m(2, true)])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n        Arraste e solte seu arquivo aqui"), _c('br'), _vm._v("\n        ou"), _c('br'), _vm._v("\n        Clique para selecionar"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-address-card fa-3x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-cloud-download fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ec9e62","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload-arquivos/index.vue
// module id = 9nt4
// module chunks = 5